import React from 'react'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

export default function Coding_QnS() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div className={classes.root}>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel1'}
        onChange={handleChange('panel1')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className="fs-6">
            1.JavaScript Practice Question
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            1. Write a JavaScript program to display the current day and time in
            the following format. Sample Output : Today is : Tuesday. Current
            time is : 10 PM : 30 : 38
            <br></br>
            <br></br>
            2.Write a JavaScript program to find the area of a triangle where
            three sides are 5, 6, 7. This JavaScript program calculates the area
            of a triangle with sides of lengths 5, 6, and 7 using Heron's
            formula. It first computes the semi-perimeter (s) of the triangle,
            then uses it to find the area, which is logged to the console.
            <br></br>
            <br></br>
            3.Write a JavaScript program to rotate the string 'w3resource' in
            the right direction. This is done by periodically removing one
            letter from the string end and attaching it to the front. The
            JavaScript program continuously rotates the string 'w3resource' to
            the right by periodically moving the last character to the front. It
            uses the setInterval function to update the string every 100
            milliseconds, modifying the text content of a specified HTML element
            by its ID.
            <br></br>
            <br></br>
            4.Write a JavaScript program where the program takes a random
            integer between 1 and 10, and the user is then prompted to input a
            guess number. The program displays a message "Good Work" if the
            input matches the guess number otherwise "Not matched".
            <br></br>
            <br></br>
            5.Write a JavaScript program to convert temperatures to and from
            Celsius, Fahrenheit. [ Formula : c/5 = (f-32)/9 [ where c =
            temperature in Celsius and f = temperature in Fahrenheit ] Expected
            Output : 60°C is 140 °F 45°F is 7.222222222222222°C
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel2'}
        onChange={handleChange('panel2')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className="fs-6">2. python Practice Question</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            1.Check if the first and last number of a list is the same.<br></br>
            Write a function to return True if the first and last number of a
            given list is same. If numbers are different then return False.
            <br></br>Given:<br></br>numbers_x = [10, 20, 30, 40, 10]<br></br>
            numbers_y = [75, 65, 35, 75, 30]<br></br>Expected Output:<br></br>
            Given list: [10, 20, 30, 40, 10]<br></br>
            result is True<br></br>
            numbers_y = [75, 65, 35, 75, 30]<br></br>
            result is False
            <br></br>
            <br></br>
            2.Format variables using a string.format() method. Write a program
            to use string.format() method to format the following three
            variables as per the expected output<br></br>
            Given:<br></br>
            totalMoney = 1000<br></br>
            quantity = 3<br></br>
            price = 450<br></br>
            Expected Output:<br></br>I have 1000 dollars so I can buy 3 football
            for 450.00 dollars.
            <br></br>
            <br></br>
            3. Print the following pattern<br></br>
            Write a program to use for loop to print the following reverse
            number pattern<br></br>5 4 3 2 1<br></br>4 3 2 1<br></br>3 2 1
            <br></br>2 1<br></br>1<br></br>
            <br></br>
            4.Remove and add item in a list<br></br>
            Write a program to remove the item present at index 4 and add it to
            the 2nd position and at the end of the list<br></br>
            Given:<br></br>
            list1 = [54, 44, 27, 79, 91, 41]<br></br>
            Expected Output:<br></br>
            List After removing element at index 4 [34, 54, 67, 89, 43, 94]
            <br></br>
            List after Adding element at index 2 [34, 54, 11, 67, 89, 43, 94]
            <br></br>
            List after Adding element at last [34, 54, 11, 67, 89, 43, 94, 11]
            <br></br>
            <br></br>
            5.Convert string into a datetime object<br></br>
            For example, You received the following date in string format.
            Please convert it into Python’s DateTime object.<br></br>
            Given:<br></br>
            date_string = "Feb 25 2020 4:20PM"<br></br>
            Expected output:<br></br>
            2020-02-25 16:20:00<br></br>
            <br></br>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel3'}
        onChange={handleChange('panel3')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className="fs-6">3. C Practice Question</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            1.Write a C program to find whether a given year is a leap year or
            not.<br></br>
            Test Data : 2016<br></br>
            Expected Output :<br></br>
            2016 is a leap year.<br></br>
            <br></br>
            2.Write a C program to calculate the root of a quadratic equation.
            <br></br>
            Test Data : 1 5 7<br></br>
            Expected Output :<br></br>
            Root are imaginary;<br></br>
            No solution.
            <br></br>
            <br></br>
            3.Write a program in C to read n number of values in an array and
            display them in reverse order.<br></br>
            Test Data :<br></br>
            Input the number of elements to store in the array :3<br></br>
            Input 3 number of elements in the array :<br></br>
            element - 0 : 2<br></br>
            element - 1 : 5<br></br>
            element - 2 : 7<br></br>
            Expected Output :<br></br>
            The values store into the array are :<br></br>2 5 7<br></br>
            The values store into the array in reverse are :<br></br>7 5 2
            <br></br>
            <br></br>
            4.Write a program in C to count the total number of duplicate
            elements in an array.<br></br>
            Test Data :<br></br>
            Input the number of elements to be stored in the array :3<br></br>
            Input 3 elements in the array :<br></br>
            element - 0 : 5<br></br>
            element - 1 : 1<br></br>
            element - 2 : 1<br></br>
            Expected Output :<br></br>
            Total number of duplicate elements found in the array is : 1
            <br></br>
            <br></br>
            5.Write a program in C to demonstrate how to handle pointers in a
            program.<br></br>
            Expected Output :<br></br>
            Address of m : 0x7ffcc3ad291c<br></br>
            Value of m : 29 <br></br>
            Now ab is assigned with the address of m. <br></br>
            Address of pointer ab : 0x7ffcc3ad291c <br></br>
            Content of pointer ab : 29 <br></br>
            The value of m assigned to 34 now. <br></br>
            Address of pointer ab : 0x7ffcc3ad291c<br></br>
            Content of pointer ab : 34 <br></br>
            The pointer variable ab is assigned with the value 7 now. <br></br>
            Address of m : 0x7ffcc3ad291c <br></br>
            Value of m : 7<br></br>
            <br></br>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel4'}
        onChange={handleChange('panel4')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className="fs-6">4. C++ Practice Question</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            1.Write a program in C++ to convert temperature in Kelvin to
            Celsius.<br></br>
            Sample Output:<br></br>
            Convert temperature in Kelvin to Celsius :<br></br>
            ------------------------------------------------<br></br>
            Input the temperature in Kelvin : 300<br></br>
            The temperature in Kelvin : 300<br></br>
            The temperature in Celsius : 26.85
            <br></br>
            <br></br>
            2.Write a C++ program to input a single-digit number and print it in
            a rectangular form of 4 columns and 6 rows.<br></br>
            Sample Output:<br></br>
            Make a rectangular shape by a single digit number :<br></br>
            --------------------------------------------------------<br></br>
            Input the number : 5<br></br>
            5555<br></br>5 5<br></br>5 5<br></br>5 5<br></br>5 5<br></br>
            5555
            <br></br>
            <br></br>
            3.Write a C++ program to calculate the volume of a cylinder.
            <br></br>
            Sample Output:<br></br>
            Calculate the volume of a cylinder :<br></br>
            -----------------------------------------<br></br>
            Input the radius of the cylinder : 4<br></br>
            Input the height of the cylinder : 8<br></br>
            The volume of a cylinder is : 401.92
            <br></br>
            <br></br>
            4.Write a C++ program to print the area of a hexagon.<br></br>
            Sample Output:<br></br>
            Print the area of a hexagon:<br></br>
            ---------------------------------<br></br>
            Input the side of the hexagon: 6<br></br>
            The area of the hexagon is: 93.5307
            <br></br>
            <br></br>
            5.Write a C++ program to add two binary numbers.<br></br>
            Sample Output:<br></br>
            Addition of two binary numbers:<br></br>
            -----------------------------------<br></br>
            Input the 1st binary number: 1010<br></br>
            Input the 2nd binary number: 0011<br></br>
            The sum of two binary numbers is: 1101<br></br>
            <br></br>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel5'}
        onChange={handleChange('panel5')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className="fs-6">5. Java Practice Question</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            1.Write a Java program to create an enum called "Weekend" with
            constants representing the days of the weekend.<br></br>
            Sample Output:<br></br>
            First day of the weekend: SATURDAY<br></br>
            Second day of the weekend: SUNDAY
            <br></br>
            <br></br>
            2.Write a Java program that reads a floating-point number and prints
            "zero" if the number is zero. Otherwise, print "positive" or
            "negative". Add "small" if the absolute value of the number is less
            than 1, or "large" if it exceeds 1,000,000.<br></br>
            Test Data<br></br>
            Input a number: 25<br></br>
            Expected Output :<br></br>
            Input value: 25<br></br>
            Positive number
            <br></br>
            <br></br>
            3.Write a Java program to make such a pattern like a right angle
            triangle with the number increased by 1.<br></br>
            The pattern like :<br></br>1<br></br>2 3<br></br>4 5 6<br></br>7 8 9
            10
            <br></br>
            <br></br>
            4.Write a Java program to print Floyd's Triangle.<br></br>
            Test Data<br></br>
            Input number of rows : 5<br></br>
            Expected Output :<br></br>
            Input number of rows : 5<br></br>1 <br></br>2 3 <br></br>4 5 6{' '}
            <br></br>7 8 9 10 <br></br>
            11 12 13 14 15
            <br></br>
            <br></br>
            5.Write a Java program to implement a lambda expression to find the
            sum of two integers.<br></br>
            Sample Output:<br></br>
            Sum 7,6): 13<br></br>
            Sum 15, -35): -20 <br></br>
            <br></br>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel6'}
        onChange={handleChange('panel6')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className="fs-6">6. Csharp Practice Question</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            1.Write a C# Sharp program to swap two numbers.<br></br>
            Test Data:<br></br>
            Input the First Number : 5<br></br>
            Input the Second Number : 6<br></br>
            Expected Output:<br></br>
            After Swapping :<br></br>
            First Number : 6<br></br>
            Second Number : 5<br></br>
            <br></br>
            2.Write a C# Sharp program to remove the character at a given
            position in the string. The given position will be in the range
            0..(string length -1) inclusive.<br></br>
            Sample Input:<br></br>
            "Python", 1<br></br>
            "Python", o<br></br>
            "Python", 4<br></br>
            Expected Output:<br></br>
            Pthon<br></br>
            ython<br></br>
            Pythn
            <br></br>
            <br></br>
            3.Write a C# Sharp program to create a string which is 4 copies of
            the 2 front characters of a given string. If the given string length
            is less than 2 return the original string.<br></br>
            Sample Input:<br></br>
            "C Sharp"<br></br>
            "JS"<br></br>
            "a"<br></br>
            Expected Output:<br></br>C C C C <br></br>
            JSJSJSJS<br></br>a<br></br>
            <br></br>
            4.Write a C# Sharp program that displays the sum of n natural
            numbers.<br></br>
            Test Data : 7<br></br>
            Expected Output :<br></br>
            The first 7 natural number is :<br></br>1 2 3 4 5 6 7<br></br>
            The Sum of Natural Number upto 7 terms : 28
            <br></br>
            <br></br>
            5.Write a C# Sharp program to read n values in an array and display
            them in reverse order.<br></br>
            Test Data :<br></br>
            Input the number of elements to store in the array :3<br></br>
            Input 3 number of elements in the array :<br></br>
            element - 0 : 2<br></br>
            element - 1 : 5<br></br>
            element - 2 : 7<br></br>
            Expected Output:<br></br>
            The values store into the array are:<br></br>2 5 7<br></br>
            The values store into the array in reverse are :<br></br>7 5 2
            <br></br>
            <br></br>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel7'}
        onChange={handleChange('panel7')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className="fs-6">
            7. typescript Practice Question
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Perceptron & multlilayer network, Backpropagation, Deep neural
            network installing libraries, Creating ANN, Python training the
            model.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel8'}
        onChange={handleChange('panel8')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel8bh-content"
          id="panel8bh-header"
        >
          <Typography className="fs-6">8. php Practice Question</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            1.Write a PHP program to create a new string where 'if' is added to
            the front of a given string. If the string already begins with 'if',
            return the string unchanged.<br></br>
            Sample Input:<br></br>
            "if else"<br></br>
            "else"<br></br>
            "if"<br></br>
            Sample Output:<br></br>
            if else<br></br>
            if else<br></br>
            if<br></br>
            <br></br>
            2.Write a PHP script that inserts a new item in an array in any
            position.<br></br>
            Expected Output :<br></br>
            Original array : <br></br>1 2 3 4 5 <br></br>
            After inserting '$' the array is :<br></br>1 2 3 $ 4 5<br></br>
            <br></br>
            3.Write a PHP script to calculate and display average temperature,
            five lowest and highest temperatures.<br></br>
            Recorded temperatures : 78, 60, 62, 68, 71, 68, 73, 85, 66, 64, 76,
            63, 75, 76, 73, 68, 62, 73, 72, 65, 74, 62, 62, 65, 64, 68, 73, 75,
            79, 73<br></br>
            Expected Output :<br></br>
            Average Temperature is : 70.6<br></br>
            List of seven lowest temperatures : 60, 62, 63, 63, 64,<br></br>
            List of seven highest temperatures : 76, 78, 79, 81, 85,<br></br>
            <br></br>
            4.Create a script to construct the following pattern, using a nested
            for loop.<br></br>* <br></br>* * <br></br>* * * <br></br>* * * *{' '}
            <br></br>* * * * * <br></br>* * * * * <br></br>* * * * <br></br>* *
            * <br></br>* * <br></br>* <br></br>
            <br></br>
            5.Write a PHP function that checks whether a passed string is a
            palindrome or not?<br></br>A palindrome is a word, phrase, or
            sequence that reads the same backward as forward, e.g., madam or
            nurses run.<br></br>
            Output: 1 (true) since 'madam' is a palindrome<br></br>
            <br></br>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
